import { NeighborhoodMapSectionWidget } from "./neighborhood-map/neighborhood-map-section-widget";
import { InsightsSectionWidget } from "./insights/insights-section-widget";
import { GeneralHeaderSectionWidget } from "./general-header/general-header-section-widget";
import { HeaderSectionWidget } from "./header/header-section-widget";
import { SectionWidget } from "./section-widget";
import { KeyFeaturesSectionWidget } from "./key-features/key-features-section-widget";
import { SideBySideComparisonSectionWidget } from "./side-by-side-comparison/side-by-side-comparison-section-widget";
import { FreeHtmlTextSectionWidget } from "./free-html-text/free-html-text-section-widget";
import { AIAssistedTextSectionWidget } from "./ai-assisted-text/ai-assisted-text-section-widget";
import { BrandingSectionWidget } from "./branding/branding-section-widget";
import { TeamBrandingSectionWidget } from "./team-branding/team-branding-section-widget";
import { HeaderBrandingSectionWidget } from "./header-branding/header-branding-section-widget";

const registry = new Map<string, SectionWidget<any, any, any>>();
const register = (sectionWidget: SectionWidget<any, any, any>) => {
  registry.set(sectionWidget.type, sectionWidget);
};

register(new HeaderSectionWidget());
register(new GeneralHeaderSectionWidget());
register(new InsightsSectionWidget());
register(new KeyFeaturesSectionWidget());
register(new NeighborhoodMapSectionWidget());
register(new SideBySideComparisonSectionWidget());
register(new FreeHtmlTextSectionWidget());
register(new AIAssistedTextSectionWidget());

// BRANDING SECTIONS
register(new BrandingSectionWidget());
register(new TeamBrandingSectionWidget());
register(new HeaderBrandingSectionWidget());

//here we can use feature flag to register optional section widgets

export const sectionWidgetRegistry = registry;
